/*
 *   File : bank.js
 *   Author : https://evoqins.com
 *   Description : dank detail page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState, useEffect } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

//custom component
import { CustomTextInput, FilePicker, RadioGroup } from '../../Component/Form-Elements';
import { BankStatusModal, ConfirmDeleteBankModal, CreateMandateModal, FindIFSCModal, MandateDetailsModal, SearchBankModal, SearchBranchModal, VerifyBankModal } from '../../Component/Modal';
import { useSelector } from 'react-redux';
import { PrimaryButton, TextButton } from '../../Component/Buttons';
import { APIService, awsService } from '../../Service';
import { Icon } from '../../Component/Icon';
import { _checkFileSize, _getProfile } from '../../Helper';

// *********** Styles ***************//  
import Colors from "../../Style/color.scss";

// *********** Assets ***************//  
import Loader from "../../Assets/Images/loader.gif";
import BankVerifyLoader from "../../Assets/Images/KYC/bank-verify-loader.gif";
import { OverLay } from '../../Component/Other';

const RETRY_LIMIT = 120; // 120 times 10mins - each 5s delay

const Bank = (props) => {

    let USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    let PROFILE_DATA = useSelector((store) => store.Reducer.SIGNUP_PROGRESS_DATA);
    let GENERAL_DATA = useSelector((store) => store.Reducer.GENERAL_DATA);
    let is_nri = PROFILE_DATA?.kyc_data?.is_nri;

    const [generalData, setGeneralData] = useState(GENERAL_DATA);
    const [bankData, setBankData] = useState({});
    const [selectedBankData, setSelectedBankData] = useState({});
    const [showBankModal, setShowBankModal] = useState(false);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [bankView, setBankView] = useState("LISTING");

    const [accountNumber, setAccountNumber] = useState("");
    const [accountNumberError, setAccountNumberError] = useState("");
    const [holderName, setHolderName] = useState("");
    const [holderNameError, setHolderNameError] = useState("");
    const [ifsc, setIfsc] = useState("");
    const [ifscError, setIfscError] = useState("");
    const [accountType, setAccountType] = useState("");
    const [ifscModal, setIfscModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const [selectedBank, setSelectedBank] = useState({});
    const [bankSearchModal, setBankSearchModal] = useState(false);
    const [branchSearchModal, setBranchSearchModal] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState({});
    const [bankList, setBankList] = useState([]);
    const [bankDataSearch, setBankDataSearch] = useState("");
    const [bankDataLoading, setBankDataLoading] = useState(true);
    const [branchList, setBranchList] = useState([]);
    const [branchSearch, setBranchSearch] = useState("");
    const [mandateData, setMandateData] = useState({});
    const [madeDefault, setMadeDefault] = useState(false);
    const [madeDefaultLoader, setMadeDefaultLoader] = useState(false);

    const [branchDataLoading, setBranchDataLoading] = useState(true);
    const [showBankDeleteModal, setShowBankDeleteModal] = useState(false);
    const [deleteBankLoader, setDeleteBankLoader] = useState(false);
    const [showMandateDetails, setShowMandateDetails] = useState(false);
    const [showMandateCreateModal, setShowMandateCreateModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);

    const [bankProofFile, setBankProofFile] = useState(null);
    const [bankProofFileError, setBankProofFileError] = useState("");
    const [bankProofViewUrl, setBankProofViewUrl] = useState(null);
    const [bankProofLoading, setBankProofLoading] = useState(false);
    const [showAddBankProofModal, setShowAddBankProofModal] = useState(false); // proof upload modal if verification is required
    const [bankId, setBankId] = useState(null);
    const [showVerifyLoader, setShowVerifyLoader] = useState(false);


    useEffect(() => {
        if (USER_DATA?.bank) {
            setBankData(USER_DATA.bank);
            setDataLoading(false);
        }

        console.log(USER_DATA);
    }, [USER_DATA]);

    useEffect(() => {
        if (GENERAL_DATA) {
            setGeneralData(GENERAL_DATA);
        }
    }, [GENERAL_DATA]);

    useEffect(() => {
        if (generalData.bank_account_types) {
            setAccountType(is_nri ? generalData?.bank_account_types[0]?.id : generalData?.bank_account_types[2]?.id);
        }
    }, [generalData]);

    // useEffect(() => {
    //     // Removing backdrop form UI when user goes back in history while filter modals opened
    //     window.addEventListener('popstate', function () {
    //         setShowBankModal(false);
    //         setShowStatusModal(false);
    //     });

    // }, [showBankModal, showStatusModal]);

    useEffect(() => {

        if (showBankModal == true) {
            let edit_modal = new Modal(document.getElementById('addBankModal'));
            edit_modal.show();
            setShowStatusModal(false);
        };

    }, [showBankModal]);

    useEffect(() => {

        if (showStatusModal == true) {
            // open status modal 
            let status_modal = new Modal(document.getElementById('bankStatusModal'));
            status_modal.show();
        };

    }, [showStatusModal]);


    useEffect(() => {
        if (ifscModal === true) {
            let ifsc_modal = new Modal(document.getElementById('find-ifsc-modal'));
            ifsc_modal.show();
        };
    }, [ifscModal]);

    useEffect(() => {
        if (bankSearchModal === true) {
            let bank_modal = new Modal(document.getElementById('bank-search-modal'));
            bank_modal.show();
        };
    }, [bankSearchModal]);

    useEffect(() => {
        if (branchSearchModal === true) {
            let branch_modal = new Modal(document.getElementById('branch-search-modal'));
            branch_modal.show();
        };
    }, [branchSearchModal]);

    useEffect(() => {
        if (showBankDeleteModal === true) {
            let bank_delete_modal = new Modal(document.getElementById('bank-delete-modal'));
            bank_delete_modal.show();
        };
    }, [showBankDeleteModal]);

    useEffect(() => {
        if (showMandateDetails === true) {
            let bank_delete_modal = new Modal(document.getElementById('mandate-details-modal'));
            bank_delete_modal.show();
        };
    }, [showMandateDetails]);

    useEffect(() => {
        if (showMandateCreateModal === true) {
            let mandate_modal = new Modal(document.getElementById('create-mandate-modal'));
            mandate_modal.show();
        };
    }, [showMandateCreateModal]);


    useEffect(() => {

        if (showAddBankProofModal) {
            let bank_modal = new Modal(document.getElementById('verify-bank-modal'));
            bank_modal.show();
        }

    }, [showAddBankProofModal]);

    useEffect(() => {
        if (bankSearchModal === true) {
            _getBank();
            setBankDataLoading(true);
        }
    }, [bankDataSearch, bankSearchModal]);

    useEffect(() => {
        if (branchSearchModal === true) {
            if (branchSearch.length > 2 || branchSearch.length === 0) {
                _getBranch();
                setBranchDataLoading(true);
            }
        }
    }, [branchSearch, branchSearchModal]);

    useEffect(() => {
        setAccountNumberError("");
    }, [accountNumber]);

    useEffect(() => {
        setHolderNameError("");
    }, [holderName]);

    useEffect(() => {
        setIfscError("");
    }, [ifsc]);

    const _handleAddNewBank = () => {
        setBankView("ADD_BANK");
        setAccountNumber("");
        setHolderName("");
        setIfsc("");
        setBankProofFile(null);
        setBankId(null);
        setBankProofViewUrl(null);
        setAccountType(is_nri ? generalData?.bank_account_types[0]?.id : generalData?.bank_account_types[2]?.id);

    };

    // handle account number
    const _handleChangeAccountNumber = (value) => {
        if (value.length <= 18) {
            setAccountNumber(value);
        }
    };

    // handle account holder name
    const _handleAccountHolderNameChange = (value) => {
        setHolderName(value);
    };

    //handle account type
    const _handleAccountType = (id) => {
        setAccountType(id)
    };

    // handle ifsc code
    const _handleChangeIfsc = (value) => {
        if (value.length <= 11) {
            setIfsc(value.toUpperCase());
        }
    };

    // handle open find ifsc modal 
    const _handleIfscModal = () => {
        setIfscModal(true);
    };

    // handle open bank search modal 
    const _handleBankSearchModal = () => {
        setBankSearchModal(true);
    };

    // handle open branch search modal 
    const _handleBranchSearchModal = () => {
        setBranchSearchModal(true);
    };

    // handle select branch 
    const _handleSelectBranch = (selected) => {
        setSelectedBranch(selected);
    };

    // handle ifsc 
    const _handleFind = (data) => {
        setIfsc(data.ifsc);
    };

    // handle select bank 
    const _handleSelectBank = (selected) => {
        setSelectedBank(selected);
    };

    const _handleBackToListing = () => {
        setBankView("LISTING");
        setSelectedBankData({});
        setMadeDefault(false);
    };

    const _handleEditBankDetails = () => {
        setBankView("EDIT_BANK");
        // Pre filling data
        setAccountNumber(selectedBankData.account_number);
        setHolderName(selectedBankData.account_holder_name);
        setIfsc(selectedBankData.ifsc);
        setAccountType(selectedBankData.account_type_id);
    };

    const _handleShowDeleteBankModal = () => {
        setShowBankDeleteModal(true);
    };

    const _handleAddNewMandate = () => {
        setShowMandateCreateModal(true);
    };

    const _handleDeleteBank = () => {
        setDeleteBankLoader(true);
        // API call
        _deleteBank();
    };

    const _handleShowBankDetails = (selected_bank) => {
        setSelectedBankData(selected_bank);
        setBankView("BANK_DETAILS");
    };

    const _handleSubmitAddBank = () => {

        let is_valid = true;

        if (accountNumber.length === 0) {
            setAccountNumberError("Provide your bank account number");
            is_valid = false;
        }

        if (holderName.length === 0) {
            setHolderNameError("Provide your full name");
            is_valid = false;
        }

        if (ifsc.length === 0) {
            setIfscError("Please provide IFSC code");
            is_valid = false;
        }

        if (PROFILE_DATA?.kyc_data?.is_nri && bankProofFile === null) {
            setBankProofFileError("Please upload bank proof");
            is_valid = false;
        }

        if (is_valid) {
            setLoading(true);
            _addAndUpdateBank();
        }

    };

    const _handleMandateSuccess = () => {
        // Updating mandate list
        _getProfile().then(res => {
            let updated_bank = res.data?.bank?.find(bank => bank.id === selectedBankData.id) || [];
            setSelectedBankData(updated_bank);
            setShowMandateCreateModal(false);
        })
    };

    const _handleShowMandateDetails = (selected_mandate) => {
        setMandateData(selected_mandate);
        setShowMandateDetails(true);
    };

    const _handleSetDefaultBank = () => {
        setMadeDefaultLoader(true);
        _setAsDefaultBank();
    };

    const _handleUploadBankProof = (file) => {

        if (file && file?.target?.files?.length !== 0) {
            const is_file_size_valid = _checkFileSize(file.target.files[0].size);

            if (is_file_size_valid === false) {
                setBankProofFileError("Maximum file size should be 5mb only");
                return;
            }
            _getPresignedUrl(file);
        } else {
            setBankProofFile(null);
        }
    };

    const _handleBankProofAddSuccess = () => {
        setShowAddBankProofModal(false);
    };

    const _handleBankProofSubmitted = () => {
        setShowAddBankProofModal(false);
        _bankSuccessHandler(bankId);
    };


    const _bankSuccessHandler = (updated_bank_id) => {

        toast.dismiss();
        toast.success(bankView === "EDIT_BANK" ? "Bank edited successfully" : "Bank added successfully", {
            className: "e-toast",
        });

        setBankView(bankView === "ADD_BANK" ? "LISTING" : "BANK_DETAILS");
        setLoading(false);

        const bank_id = updated_bank_id;

        _getProfile().then(res => {
            if (bankView === "EDIT_BANK" && bank_id) {
                let updated_bank = res.data?.bank?.find(bank => bank.id === bank_id) || [];
                setSelectedBankData(updated_bank);
            }
        })
    };


    //==================================== //
    //=========== API CAllS ============== //


    //API- Get bank list
    const _getBank = () => {
        let is_post = true;
        let url = 'general/banks';
        let data = {
            "query": bankDataSearch.length !== 0 ? bankDataSearch : null
        };
        let token = sessionStorage.getItem('access_token');


        APIService(is_post, url, data, token).then((response) => {
            if (response.status_code === 200) {
                setBankList(response.data);
            } else {
                setBankList([]);
            }
            setBankDataLoading(false);
        });
    };

    //API- Get branch list
    const _getBranch = () => {
        let is_post = true;
        let url = 'general/branches';
        let data = {
            "bank_id": selectedBank.id,
            "query": branchSearch.length !== 0 ? branchSearch : null
        };
        let token = sessionStorage.getItem('access_token');

        APIService(is_post, url, data, token).then((response) => {
            if (response.status_code === 200) {
                setBranchList(response.data);
            } else {
                setBranchList([]);
            }
            setBranchDataLoading(false);
        });
    };

    //API- Post update bank 
    const _addAndUpdateBank = () => {
        let is_post = true;
        let api_version = 2;
        let url = 'profile/bank/update';
        let data = {
            "account_number": accountNumber,
            "account_holder_name": holderName,
            "account_type": accountType,
            "ifsc": ifsc,
            "is_default": bankView === "EDIT_BANK" ? selectedBankData.is_default : false,
            "bank_id": bankView === "EDIT_BANK" ? selectedBankData.id : undefined,
            "bank_proof_url": PROFILE_DATA?.kyc_data?.is_nri ? bankProofViewUrl : undefined,
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                const { mandate_url, should_verify, bank_id } = response.data;

                setBankId(bank_id);

                if (!should_verify) {
                    _bankSuccessHandler(bank_id);
                } else {
                    _verifyBank(RETRY_LIMIT, bank_id);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",

                });
                setLoading(false);
            }
        });
    };

    //API- Post update bank 
    const _deleteBank = () => {
        let is_post = true;
        let api_version = 2;
        let url = 'profile/bank/delete';
        let data = {
            "id": selectedBankData.id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                _getProfile().finally(() => {

                    toast.success("Bank deleted successfully", {
                        className: "e-toast",
                    });

                    // Closing delete modal
                    let modal_close_btn = document.querySelector("#bank-delete-modal-close");
                    modal_close_btn.click();

                    setBankView("LISTING");
                });


            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",

                });
            }
            setDeleteBankLoader(false);
        });
    };

    //API- Post update bank 
    const _setAsDefaultBank = () => {
        let is_post = true;
        let api_version = 2;
        let url = 'profile/bank/default';
        let data = {
            "id": selectedBankData.id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                _getProfile().then((res) => {
                    let updated_bank = res.data?.bank?.find(bank => bank.id === selectedBankData.id) || [];
                    setSelectedBankData(updated_bank);
                }).finally(() => {
                    toast.success("Successfully set as primary bank.", {
                        className: "e-toast",
                    });
                    setMadeDefault(true);
                });

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",

                });
            }
            setMadeDefaultLoader(false);
        });
    };

    //get presigned url
    async function _getPresignedUrl(file) {

        setBankProofLoading(true);

        let file_name = file.target.files[0].name;

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": file.target.files[0].type,
            "file": file_name,
            "is_public": true
        };

        try {
            let response = await APIService(is_post, url, data);
            let aws_URL = '';
            if (response.status_code == 200) {

                aws_URL = response.data.upload_info.url;
                let view_url = response.data.view_info;

                let file_param = new File(
                    [file.target.files[0]],
                    file.target.files[0].name,
                    { type: file.target.files[0].type }
                );

                try {
                    let awsResponse = await awsService(response.data.upload_info.fields, file_param, aws_URL);

                    if (awsResponse.status == 'ok') {
                        setBankProofViewUrl(view_url);
                        setBankProofFile(file.target.files[0]);
                        setBankProofFileError("");
                    } else {
                        toast.dismiss();
                        toast.error(awsResponse.message, { className: "e-toast" });
                    }
                } catch (err) {
                    toast.dismiss();
                    toast.error(err.message, { className: "e-toast" });
                }
            }

            setBankProofLoading(false);

        } catch (err) {
            setBankProofLoading(false);
        }
    };

    //API- Check bank verification status
    const _verifyBank = async (retry = RETRY_LIMIT, updated_bank_id = bankId) => {

        let api_version = 3;
        let is_post = false;
        let url = 'kyc/check-bank-verification';
        let data = null;
        let token = sessionStorage.getItem('access_token');

        let response = await APIService(is_post, url, data, token, api_version)
        if (response.status_code === 200) {

            if (response.data.status === "SUCCESS") {
                _bankSuccessHandler(updated_bank_id);
                setShowVerifyLoader(false);
            } else if (response.data.status === "FAILED") {

                if (response.data.proof_required === true) {
                    setLoading(false);
                    setShowAddBankProofModal(true);
                } else {
                    toast.dismiss();
                    toast.error(response.data.message, {
                        className: "e-toast",
                    });
                    setLoading(false);
                }

                setShowVerifyLoader(false);

            } else {
                // Poll until status is no longer PENDING
                await new Promise((resolve) => setTimeout(resolve, 5000));
                let re_try_limit = retry ?? RETRY_LIMIT; // totally 10 times

                if (!re_try_limit) {
                    toast.dismiss();
                    toast.error(`Bank ${bankView === "EDIT_BANK" ? "edited" : "added"} successfully, but verification is pending`, {
                        className: "e-toast",
                    });
                    setLoading(false);
                    return;
                } else {
                    setShowVerifyLoader(false);
                }

                await _verifyBank(--re_try_limit, updated_bank_id);
            }
        } else {
            toast.dismiss();
            toast.error(response.message, {
                className: "e-toast",
            });
            setLoading(false);
            setShowVerifyLoader(false);
        }

    };

    // Inline Component
    const TitleButton = ({ title, onClick }) => {
        return (
            <div className="d-inline-flex gap-3 align-items-center mb-3 cursor-pointer" onClick={onClick}>
                <Icon icon="arrow-back-left"
                    className="cursor-pointer"
                    size={24} />
                <h3 className='mb-0 e-text-charleston-green e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                    {title}
                </h3>
            </div>
        )
    };

    const VerifyLoader = () => (
        <>
            <OverLay isOpen={true} onClose={() => { }} />
            <div className="position-fixed top-50 start-50 translate-middle e-bg-lotion e-border-radius-24 e-modal-box-shadow z-index-99">
                <div className="modal-gradient-bg d-flex flex-column align-items-center justify-content-between modal-body p-4 e-border-radius-24">
                    <img src={BankVerifyLoader}
                        className="object-fit-contain mt-4"
                        draggable={false}
                        alt="bank verification loader" />
                    <p className="e-font-14-res text-center e-text-charleston-green e-alt-font-poppins e-font-18 e-font-weight-600 mb-2">
                        We are verifying your bank details
                    </p>
                    <p className="e-font-12-res text-center e-text-dark-liver e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px mb-0">
                        Please keep the app open while this process completes.
                    </p>
                </div>
            </div>
        </>
    );

    return (

        <div className='col-12'>



            {
                dataLoading ?
                    <div className="min-h-100vh text-center mt-5 pt-5" >
                        <img src={Loader}
                            width={24}
                            className='object-fit-contain'
                            draggable="false"
                            alt="loader" />
                    </div>
                    :
                    bankView === "LISTING" &&
                    <>
                        <div className="d-flex justify-content-between  align-items-center mb-3">
                            <h3 className='mb-0 e-text-charleston-green e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                Bank account details
                            </h3>
                            <TextButton name="+Add another bank"
                                type={2} icon={false}
                                className={"d-none d-sm-inline-flex"}
                                onClick={_handleAddNewBank} />
                        </div>
                        <div className="row row-gap-4">
                            {
                                bankData.length &&
                                bankData.map((bank, index) => {
                                    return (
                                        <div className="col-sm-6" key={index}>
                                            <div className="d-flex flex-column gap-2 p-3 e-bg-cultured e-border-radius-16 h-100 cursor-pointer  hover-arrow-wrapper" onClick={() => _handleShowBankDetails(bank)}>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="e-text-charleston-green  e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-500 line-height-20px mb-0">
                                                        {bank?.bank_name}
                                                    </p>
                                                    <div className="d-flex align-items-center gap-2">
                                                        {
                                                            bank?.is_default && <span className='px-2 py-1 e-border-radius-16 e-bg-alice-blue_2  e-text-raisin-black e-font-10 e-alt-font-poppins e-font-weight-500'>Primary</span>
                                                        }
                                                        <span className='hover-arrow'>
                                                            <Icon icon="arrow-down"
                                                                size={12}
                                                                className="transform-rotate-min-90 "
                                                                onClick={() => { }} />
                                                        </span>
                                                    </div>
                                                </div>
                                                <p className="d-flex gap-2-all align-items-center e-text-granite-gray  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px mb-0">
                                                    {
                                                        Array.from({ length: 4 }).map((_, index) => (
                                                            <Icon
                                                                key={index}
                                                                icon="bullet"
                                                                color={Colors.granite_gray}
                                                                size={"0.25rem"}
                                                            />
                                                        ))
                                                    }
                                                    {bank?.account_number && bank?.account_number.slice(-4)}
                                                </p>
                                                <p className="d-flex flex-column flex-sm-row gap-2-all align-items-sm-center e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px mb-0">
                                                    {bank?.account_holder_name}
                                                    <Icon icon="bullet"
                                                        className="d-none d-sm-block"
                                                        color={Colors.granite_gray}
                                                        size={"0.25rem"} />
                                                    IFSC: {bank?.ifsc}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="d-block d-sm-none  text-center mt-4">
                            <TextButton name="+Add another bank"
                                type={2} icon={false}
                                onClick={_handleAddNewBank} />
                        </div>
                    </>
            }

            {
                (bankView === "ADD_BANK" || bankView === "EDIT_BANK") &&
                <>
                    <TitleButton title={bankView === "ADD_BANK" ? "Add Bank" : "Edit Bank"} onClick={() => setBankView(bankView === "ADD_BANK" ? "LISTING" : "BANK_DETAILS")} />
                    <div className="row row-cols-1 gx-gy-32px">


                        <div className="col" id='account-number'>
                            <CustomTextInput label="Account number*"
                                placeholder="99980107428"
                                type="text"
                                style="number"
                                maxLength={18}
                                floatingLabel
                                value={accountNumber}
                                errorMsg={accountNumberError}
                                handleChange={_handleChangeAccountNumber} />
                        </div>
                        <div className="col" id="account-holder">
                            <CustomTextInput label="Account holder name*"
                                placeholder="Jhon Doe"
                                type="text"
                                floatingLabel
                                value={holderName}
                                errorMsg={holderNameError}
                                handleChange={_handleAccountHolderNameChange} />
                        </div>

                        <div className="col position-relative" id="ifsc-code">
                            {/* IFSC code */}
                            <div className="position-relative">
                                <CustomTextInput label="IFSC code*"
                                    placeholder="SBIN0001234"
                                    type="text"
                                    floatingLabel
                                    value={ifsc}
                                    errorMsg={ifscError}
                                    handleChange={_handleChangeIfsc} />
                                {/* find ifsc  */}
                                <p className='mb-0 text-end'>
                                    <span className='position-absolute top-100 end-0 pe-1 bg-white pt-1 e-text-egyptian-blue  e-font-12 e-alt-font-poppins e-font-weight-500 line-height-14px  cursor-pointer text-decoration-hover-underline'
                                        onClick={_handleIfscModal}>
                                        Find IFSC code
                                    </span>
                                </p>
                            </div>
                        </div>
                        {/* Upload bank proof card */}
                        {
                            PROFILE_DATA?.kyc_data?.is_nri &&
                            <div className="col" id='bank-proof'>
                                <FilePicker id="bank-proof-image"
                                    label="Upload bank proof (max. 5mb)*"
                                    type="file"
                                    className="w-100"
                                    accept=".png, .jpg, .jpeg"
                                    isFileUploading={bankProofLoading ? true : false}
                                    file={bankProofFile}
                                    error={bankProofFileError}
                                    selectFile={_handleUploadBankProof} />
                            </div>
                        }

                        <div className="col" id='account-type'>
                            <h6 className='margin-12px-bottom e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-400'>
                                Account type*
                            </h6>
                            <div className='d-flex flex-wrap gap-3'>
                                <RadioGroup data={generalData.bank_account_types}
                                    selected={accountType}
                                    handleSelect={_handleAccountType} />
                            </div>
                        </div>

                    </div>
                    <div className="row justify-content-end mt-5">
                        <div className="col-auto col-sm-5  flex-fill-res ">
                            <PrimaryButton name={bankView === "EDIT_BANK" ? "Update" : 'Add'}
                                loading={loading}
                                disabled={loading}
                                className={`w-100 padding-14px-tb padding-8px-tb-res padding-12px-lr-res e-font-14`}
                                onPress={_handleSubmitAddBank} />
                        </div>
                    </div>
                </>
            }

            {
                bankView === "BANK_DETAILS" &&
                <>
                    <TitleButton title="Account Details" onClick={_handleBackToListing} />
                    <div className="row mb-3">
                        <div className="col">
                            <div className="d-flex flex-column gap-3 p-3 e-bg-cultured e-border-radius-16 h-100  hover-arrow-wrapper">
                                <div className="d-flex align-items-start justify-content-between">
                                    <p className="d-flex flex-column gap-2 e-text-charleston-green  e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-500 line-height-20px mb-0">
                                        {selectedBankData?.bank_name}
                                        <span className='e-text-charleston-green e-font-12 e-font-weight-400'>
                                            {selectedBankData?.account_type} Account
                                        </span>
                                    </p>
                                    <div className='d-flex gap-2 cursor-pointer'>
                                        <Icon icon="edit-data-icon"
                                            size={14}
                                            color={Colors.dark_jet}
                                            onClick={_handleEditBankDetails} />
                                        <Icon icon="delete"
                                            size={14}
                                            color={Colors.dark_jet}
                                            onClick={_handleShowDeleteBankModal} />
                                    </div>
                                </div>

                                <div className="row justify-content-between row-gap-3">
                                    <div className='col-auto'>
                                        <p className='mb-0 e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px'>
                                            Holder name
                                        </p>
                                        <p className='mb-0 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'>
                                            {selectedBankData?.account_holder_name}
                                        </p>
                                    </div>
                                    <div className='col-auto'>
                                        <p className='mb-0 e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px'>
                                            IFSC Code
                                        </p>
                                        <p className='mb-0 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'>
                                            {selectedBankData?.ifsc}
                                        </p>
                                    </div>
                                    <div className='col-auto'>
                                        <p className='mb-0 e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px'>
                                            Account number
                                        </p>
                                        <p className='mb-0 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'>
                                            {selectedBankData?.masked_account_number}
                                            {
                                                selectedBankData?.is_default && <span className='px-2 py-1 ms-2 e-border-radius-16 e-bg-alice-blue_2  e-text-raisin-black e-font-10 e-alt-font-poppins e-font-weight-500'>Primary</span>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {
                        (selectedBankData.is_default === false || madeDefault === true) &&
                        <div className={`${madeDefault ? "pe-none" : ""} ${madeDefaultLoader ? "pe-none opacity-50" : ""} mb-2 d-inline-flex gap-2 align-items-center cursor-pointer`}
                            onClick={_handleSetDefaultBank}>
                            <Icon icon={madeDefault ? "succesfull" : "circle-inactive"}
                                size={14} />
                            <span className='e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'>
                                Set as Primary
                            </span>
                        </div>
                    }

                    {
                        selectedBankData.is_default &&
                        <>
                            <h3 className=' e-text-charleston-green e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                Active Mandates
                            </h3>
                            <div className="row mb-4 row-gap-4">
                                {
                                    selectedBankData.mandates.length !== 0 ?
                                        selectedBankData.mandates.map((data, index) => (
                                            <div className="col-sm-6" key={index}>
                                                <div className="d-flex justify-content-between align-items-center e-border-1px-anti-flash-white-light py-2 padding-12px-lr e-border-radius-16 cursor-pointer"
                                                    onClick={() => _handleShowMandateDetails(data)}>
                                                    <div className="d-flex flex-column">
                                                        <p className='mb-2 e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px'>
                                                            Mandate {index + 1}
                                                        </p>
                                                        <p className='mb-0 e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-20px'>
                                                            Expires on {data.end_date}
                                                        </p>

                                                    </div>
                                                    <span className='hover-arrow'>
                                                        <Icon icon="arrow-down"
                                                            size={12}
                                                            className="transform-rotate-min-90 "
                                                            onClick={() => { }} />
                                                    </span>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className="col-auto">
                                            <p className=" e-bg-cornsilk e-border-radius-16 p-sm-3  p-2 e-text-ochre e-alt-font-poppins e-font-14 e-font-weight-400 line-height-24px" >
                                                There is no active mandate, Please create a new one.
                                            </p>
                                        </div>
                                }

                            </div>
                            <div className="row justify-content-end mt-4">
                                <div className="col-auto col-sm-6  flex-fill-res ">
                                    <PrimaryButton name='Add new mandate'
                                        loading={loading}
                                        disabled={loading}
                                        className={`w-100 padding-14px-tb padding-8px-tb-res padding-12px-lr-res e-font-14`}
                                        onPress={_handleAddNewMandate} />
                                </div>
                            </div>
                        </>
                    }

                </>
            }


            {showVerifyLoader && <VerifyLoader />}


            {/*  bank status modal */}
            {
                showStatusModal &&
                <BankStatusModal onCloseModal={() => {
                    setShowStatusModal(false)
                }} />
            }

            {/* find ifsc modal  */}
            {
                ifscModal === true &&
                <FindIFSCModal selectedBank={selectedBank}
                    selectedBranch={selectedBranch}
                    bankSearchModal={_handleBankSearchModal}
                    branchSearchModal={_handleBranchSearchModal}
                    onModalClose={() => {
                        setIfscModal(false);
                        setSelectedBank({});
                        setSelectedBranch({});
                    }}
                    handleFind={_handleFind} />
            }

            {/* bank search modal  */}
            {
                bankSearchModal === true &&
                <SearchBankModal data={bankList}
                    selectedBank={selectedBank}
                    bankLoading={bankDataLoading}
                    searchValue={bankDataSearch}
                    handleClearSearch={() => setBankDataSearch("")}
                    handleSearch={(value) => setBankDataSearch(value)}
                    handleSelectedBank={_handleSelectBank}
                    onModalClose={() => {
                        setBankSearchModal(false);
                        setBankDataSearch("");
                    }} />
            }

            {/* branch search modal  */}
            {
                branchSearchModal === true &&
                <SearchBranchModal data={branchList}
                    selectedBranch={selectedBranch}
                    branchLoading={branchDataLoading}
                    searchValue={branchSearch}
                    handleClearSearch={() => setBranchSearch("")}
                    handleSearch={(value) => setBranchSearch(value)}
                    handleSelectedBranch={_handleSelectBranch}
                    onModalClose={() => {
                        setBranchSearchModal(false);
                        setBranchSearch("");
                    }} />
            }

            {
                showBankDeleteModal &&
                <ConfirmDeleteBankModal bankNumber={selectedBankData.account_number.slice(-4)}
                    loading={deleteBankLoader}
                    onDeleteBank={_handleDeleteBank}
                    onCloseModal={() => setShowBankDeleteModal(false)} />
            }

            {
                showMandateDetails &&
                <MandateDetailsModal data={mandateData} onCloseModal={() => setShowMandateDetails(false)} />
            }

            {
                showMandateCreateModal &&
                <CreateMandateModal handleSuccess={_handleMandateSuccess} onCloseModal={() => setShowMandateCreateModal(false)} />
            }

            {
                showAddBankProofModal &&
                <VerifyBankModal
                    flowType={2}
                    bankId={bankId}
                    onSuccess={_handleBankProofSubmitted}
                    onClose={() => setShowAddBankProofModal(false)} />
            }

        </div >
    )
}

export default Bank;